import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 100%;

  p {
    font-size: 1.4rem;
    color: #666;
  }

  > div:not(:first-child) {
    margin-top: 3rem;
  }
`;
